import type { ReactNode } from "react";

/** 图标外框：Lucide 的 24 网格线性图标，显示为 16px、描边 1.75、颜色继承文字（设计系统"图标"一节）。children 是 Lucide 图标的 path 等元素。 */
export function Icon({ children }: { children: ReactNode }) {
  return (
    <svg className="ax-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      {children}
    </svg>
  );
}
